import { rmmDeleteDescription as description } from './description';
import { deleteAlert as execute } from './execute';

export { description, execute };
